/**
 * The prompt shown when a `?team_id=` link meets a registration already in
 * progress in this browser. Kept in one place so the wording can change
 * without touching the page that shows it.
 */
export const SESSION_LINK_CONFLICT_COPY = {
  title: 'You Have A Running Session',
  description: 'Do you want to start over with the new registration link?',
  cancelLabel: 'CANCEL',
  confirmLabel: 'START OVER',
} as const
